









































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import { CensusManager } from "@/employer/types";
import { Employer } from "@/admin/types";
import {
  EnrollmentOption,
  FetchState
} from "@/shared/types";
import { useEmployerStore } from "@/admin/store/employer";


@Component
export default class CensusManagerView extends Vue {
  @Prop() employerId: number;

  employerStore = useEmployerStore();

  selectedCensusManager = CensusManager.bend;
  CensusManager = CensusManager;

  mounted (): void {
    this.selectedCensusManager = this.employer.censusManager;
  }

  @Watch("employer")
  onEmployerUpdated (): void {
    this.selectedCensusManager = this.employer.censusManager;
  }

  get employer (): Employer {
    const loadedEmployer = this.employerStore.employerDetail(this.employerId);
    return loadedEmployer.loaded && loadedEmployer.employer;
  }

  get isLoaded (): boolean {
    return this.employer && this.employerStore.censusManagerFetchState !== FetchState.Loading;
  }

  get isBulk (): boolean {
    return this.employer.enrollmentOption === EnrollmentOption.EmployerBulk;
  }

  get bulkMessage (): string {
    return this.isBulk ? "While the enrollment option for this employer is set to bulk, this setting cannot be changed."
        : "";
  }

  onSubmit (): void {
    this.employerStore.saveCensusManager({
      employerId: this.employerId,
      censusManager: this.selectedCensusManager
    });
  }
}

